import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import { imageUrl } from "../../config/Url";
import { showNotification } from "../Landing/Landing.slice";
import { titleColor } from "../../config/ColorObj";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const MyLeaveViewPopup = ({
  handleCloses,
  open,
  DataToSet,
  showNotification,
  viewData,
}) => {

  const onClickPreview = () => {
    if (viewData.attachFile) {
      window.open(imageUrl + viewData.attachFile, '_blank')
    } else {
      showNotification({ msg: "No Attachment Found", severity: "error" })
    }
  }

  const handleClose = () => {
    handleCloses();
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          My Leave Details
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <DynamicDetails DataToSet={DataToSet} />

          {viewData.attachFile && (
            <Grid
              item
              container
              sm={12}
              xs={12}
              md={6}
              lg={6}
              alignItems="center"
              marginLeft={2}
              sx={{ marginTop: 3 }}
            >
              <Grid item xs={12} sm={4} md={4}>
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: titleColor }}
                  label="Attachment:"
                />
              </Grid>
              <Grid item xs={12} sm={8} md={8}>
                <MyComponentWithIconProps
                  statusImage={VisibilityIcon}
                  color="primary"
                  fontSize="medium"
                  title="View"
                  onClick={onClickPreview}
                />
              </Grid>
            </Grid>
          )}

        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyLeaveViewPopup);
